import { React, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import OtpInput from 'react-otp-input';
import webServices from '../../../services/webServices';

const VerifyOtpComponent = (props) => {
  const otpLength = 4;
  const { user, emailVerifiedHandler } = props;
  const [otp, setOtp] = useState('');
  const [formData, setFormData] = useState({
    isHelpVisible: false,
    isBtnDisabled: false
  });

  const handelResendOtpBtn = async () => {
    // Trying to re-send otp to email
    setFormData((prev) => ({ ...prev, isBtnDisabled: true }));
    const result = await webServices.sendOtp({ email: user.email, isResend: 1 });
    setFormData((prev) => ({ ...prev, isBtnDisabled: false }));
    if (result && result.success === true) {
      toast.success("OTP has been send to your mentioned zelle email.");
    }
  }

  const handelVerifyOtpBtn = async () => {
    // Trying to verify otp
    setFormData((prev) => ({ ...prev, isBtnDisabled: true }));
    const result = await webServices.verifyOtp({ otp });
    setFormData((prev) => ({ ...prev, isBtnDisabled: false }));
    if (result && result.success === true) {
      emailVerifiedHandler();
    }
  }

  return (
    <>
      We sent you a One Time Passcode to your email id. Use that code to confirm your mobile number.

      <div className="row w-100 settingOtp">
        <div className="col-12 d-flex align-items-end justify-content-center">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={otpLength}
            containerStyle="userOtpBbox"
            inputStyle="inputStyleNew"
            shouldAutoFocus
            className="inputStyleNew focus-color otpInput"
            isInputNum
          />
        </div>
      </div>

      <div className='d-flex resend-wrapper'>
        <span> Didn&apos;t get the code? </span>
        <button type="button" className="btn btn-info" onClick={handelResendOtpBtn} disabled={formData.isBtnDisabled}>Resend Code</button>
      </div>
      <div className='text-center very_otp'>
        <button type="button" className="btn btn-info theme-btn ml-3 r_color mb-2 mb-md-0 mt-0" onClick={handelVerifyOtpBtn} disabled={formData.isBtnDisabled}>
          Verify OTP
        </button>
      </div>
    </>
  );
};

const VerifyZelleIdPopup = (props) => {
  const { isModalVisible, handelClose, emailVerifiedHandler, user } = props;

  const emailVerifiedEvt = () => {
    handelClose();
    emailVerifiedHandler();
  }

  return (
    <>
      <Modal
        className="filter-model PlanStatusModel aff_login paymentModel studentPlanModal"
        show={isModalVisible}
        onHide={handelClose}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="row">
              <div className="col-md-12">
                <h5 className="modal-title w-100">
                  Confirm your<br />phone with OTP
                </h5>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="loader-payment0">
          <VerifyOtpComponent user={user} emailVerifiedHandler={emailVerifiedEvt} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VerifyZelleIdPopup;
